import type { LocalDaemonAdapterContainer } from "@wakeloop/local-service";
import type {
  DaemonRuntimeAdapterCapabilitySnapshot,
  LocalComponentsStatus,
  RuntimeTransportCapabilities,
} from "@wakeloop/schemas/types";
import { resolveRegistryRuntimeAdapterCapabilitySnapshot } from "../../agents/registry-source";

export function resolveDaemonCapabilities(input: {
  localAdapterContainer: LocalDaemonAdapterContainer;
  localComponentsStatus?: LocalComponentsStatus | null;
}): RuntimeTransportCapabilities {
  const runtimeAdapters = input.localAdapterContainer
    .listAdapters()
    .map((entry) =>
      resolveRegistryRuntimeAdapterCapabilitySnapshot(entry.adapterId)
    )
    .filter(
      (entry): entry is DaemonRuntimeAdapterCapabilitySnapshot => entry !== null
    )
    .sort((left, right) => left.adapterId.localeCompare(right.adapterId));

  return {
    ...(input.localComponentsStatus
      ? { localComponents: input.localComponentsStatus }
      : {}),
    localAgentControl: {
      cancel: true,
      interrupt: true,
      refreshCatalog: true,
      setEnabled: true,
    },
    ...(runtimeAdapters.length > 0 ? { runtimeAdapters } : {}),
  };
}
